// src/store/plugins/localForagePersist.ts
import { toRaw } from 'vue';
import localforage from 'localforage';

const localForagePersist = (context) => {
  const storeId = context.store.$id;

  // Exclude logStore from being persisted in localForage
  if (storeId === 'log') {
    return; // Skip logStore
  }

  /* BELOW NOW HANDLED IN BY hydrateStores.ts UPON APP INITIALIZATION
  // Load the persisted state when the store is initialized
  localforage.getItem(storeId).then((savedState) => {
    if (savedState) {
      context.store.$patch(savedState);

      // Get store name
      const storeName = context.store.$id;

      console.log(
        `State for ${storeName} loaded from LocalForage: ${savedState}`
      );
    }
    if (context.store.init) {
      context.store.init();
    }
  });*/

  // Save the raw state to LocalForage whenever it changes
  context.store.$subscribe((_mutation, state) => {
    const rawState = toRaw(state); // Convert the reactive state to a plain object
    const shallowCopyState = { ...rawState }; // Create a shallow copy of the state

    // Check savedState keys for those beginning with pr_ (private data) and remove them
    for (const key in shallowCopyState) {
      // if has property value, get the raw value

      // Handle conversion of refs (setup stores)
      if (
        typeof shallowCopyState[key] === 'object' &&
        shallowCopyState[key] &&
        'value' in shallowCopyState[key]
      ) {
        shallowCopyState[key] = toRaw(shallowCopyState[key].value);
      } else {
        shallowCopyState[key] = toRaw(shallowCopyState[key]);
      }

      if (key.startsWith('pr_')) {
        delete shallowCopyState[key];
      }
    }

    const deepCopyState = JSON.parse(JSON.stringify(shallowCopyState)); // Create a deep copy of the state

    localforage
      .setItem(storeId, deepCopyState)
      .then(() => {
        //console.log(`State saved to LocalForage for store ${storeId}`);
      })
      .catch((error) => {
        console.error('Error saving state to LocalForage:', error);
      });
  });

  // Save the state to LocalForage whenever it changes
  //context.store.$subscribe((mutation, state) => {
  //  localforage.setItem(storeId, state);
  //});
};

export default localForagePersist;
